// Lesson types and their badge-counting defaults. Mirrors `resolve_lesson_type` /
// `default_counts_badges` in server/main/pydantic_models/content/lesson.py.

export const LESSON_TYPE_STANDARD = "STANDARD";
export const LESSON_TYPE_PRACTICE = "PRACTICE";
export const LESSON_TYPE_REFLECTION = "REFLECTION";

export const LESSON_TYPE_OPTIONS = [
  { value: LESSON_TYPE_STANDARD, label: "Standard" },
  { value: LESSON_TYPE_PRACTICE, label: "Practice" },
  { value: LESSON_TYPE_REFLECTION, label: "Reflection" },
];

/** Practice sessions earn badges like role plays do; other lesson types do not by default. */
export const defaultCountsBadges = (lessonType) => lessonType === LESSON_TYPE_PRACTICE;

/** A linked lesson is always a reflection; otherwise its explicit type, else standard. */
export const resolveLessonType = (lesson) => {
  if (lesson?.reflects_on_scenario_id != null) return LESSON_TYPE_REFLECTION;
  return lesson?.lesson_type || LESSON_TYPE_STANDARD;
};

export const LESSON_TYPE_LABEL = "Lesson type";
export const LESSON_TYPE_TOOLTIP =
  "Standard: a regular lesson. Practice: a practice session (counts badges by default). " +
  "Reflection: debriefs a role play you link below.";

export const COUNTS_BADGES_TOOLTIP =
  "When on, each time a learner finishes this item it earns a badge (and its coin), and the " +
  "course map shows badges instead of a repeat count.";
